// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.filterBtn {
    margin: 15px 5px 0 5px;
}

.issuanceReport ::ng-deep  td.mat-cell{
    padding-right: 20px !important;
}

.issuanceReport ::ng-deep  th.mat-header-cell{
  padding-right: 2px !important; 
} 
.phone-number{
  width:135px
}
/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImlzc3VhbmNlLXJlcG9ydC5jb21wb25lbnQuY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0lBQ0ksc0JBQXNCO0FBQzFCOztBQUVBO0lBQ0ksOEJBQThCO0FBQ2xDOztBQUVBO0VBQ0UsNkJBQTZCO0FBQy9CO0FBQ0E7RUFDRTtBQUNGIiwiZmlsZSI6Imlzc3VhbmNlLXJlcG9ydC5jb21wb25lbnQuY3NzIiwic291cmNlc0NvbnRlbnQiOlsiLmZpbHRlckJ0biB7XG4gICAgbWFyZ2luOiAxNXB4IDVweCAwIDVweDtcbn1cblxuLmlzc3VhbmNlUmVwb3J0IDo6bmctZGVlcCAgdGQubWF0LWNlbGx7XG4gICAgcGFkZGluZy1yaWdodDogMjBweCAhaW1wb3J0YW50O1xufVxuXG4uaXNzdWFuY2VSZXBvcnQgOjpuZy1kZWVwICB0aC5tYXQtaGVhZGVyLWNlbGx7XG4gIHBhZGRpbmctcmlnaHQ6IDJweCAhaW1wb3J0YW50OyBcbn0gXG4ucGhvbmUtbnVtYmVye1xuICB3aWR0aDoxMzVweFxufSJdfQ== */`, "",{"version":3,"sources":["webpack://./src/app/secure/reports/issuance-report/issuance-report.component.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;AAC1B;;AAEA;IACI,8BAA8B;AAClC;;AAEA;EACE,6BAA6B;AAC/B;AACA;EACE;AACF;AACA,orBAAorB","sourcesContent":[".filterBtn {\n    margin: 15px 5px 0 5px;\n}\n\n.issuanceReport ::ng-deep  td.mat-cell{\n    padding-right: 20px !important;\n}\n\n.issuanceReport ::ng-deep  th.mat-header-cell{\n  padding-right: 2px !important; \n} \n.phone-number{\n  width:135px\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
